import React from 'react';

export default function IcMobile(props) {
  return (
    <svg width='1em' height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M14 4H16V20H8L8 4H10C10 4.55228 10.4477 5 11 5H13C13.5523 5 14 4.55228 14 4ZM6 4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V4Z" 
        fill="currentColor" />
    </svg>
  );
}
